// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__36fYE","productName":"Table_productName__2LR4b"};